const { getElement, getOffsetTop, viewportSize } = window.BAO.Utils

class FloatingNavigation extends window.BAO.CustomElement() {
  itemsArray = []

  connectedCallback () {
    super.connectedCallback()

    this.sectionEls = this.externalEls?.section?.elements
    this.mobileSectionEls = this.sectionEls?.filter(el =>
      el.matches(":not([data-floating-nav-section-type='parent'])"),
    )
    this.desktopSectionEls = this.sectionEls?.filter(el =>
      el.matches(":not([data-floating-nav-section-type='child'])"),
    )

    this.itemsEl = this.els?.items?.element

    this.currentItem = null
    this.overlappingSection = null

    if (!this.sectionEls) return

    this.sectionEls.forEach(section => {
      this.buildItems(section.dataset.floatingNavigationTitle)
    })
    this.buttonEls = this.els?.button?.elements

    this.setHeight()
    this.setActiveSection()

    if (this.buttonEls) {
      this.buttonEls.forEach(button => {
        this.listeners.add(button, 'click', this.onClick.bind(this))
      })
    }

    this.listeners.add(window, 'resize', this.onResize.bind(this))
    this.listeners.add(window, 'scroll', this.onScoll.bind(this))

    this.setAttribute('aria-hidden', false)
  }

  onResize () {
    this.setHeight()
    this.setActiveSection()
    this.setItemsColour()
  }

  onScoll () {
    this.setActiveSection()
    this.setItemsColour()
  }

  setHeight () {
    if (!this.sectionEls) return

    this.style.setProperty(
      '--FloatingNavigation_SectionHeight',
      `${this.sectionEls[0].offsetHeight}px`,
    )
  }

  buildItems (link) {
    if (!link) return

    if (!this.itemsArray.includes(link.toLowerCase())) {
      this.itemsArray.push(link.toLowerCase())

      const item = document.createElement('li')
      item.classList.add('nav-FloatingNav_Item')

      const button = document.createElement('button')
      button.classList.add('nav-FloatingNav_Link', 'fz-12_140')
      button.setAttribute('data-floating-navigation-el', 'button')
      button.setAttribute('data-floating-navigation-title', link)

      button.appendChild(document.createTextNode(link))

      item.appendChild(button)

      this.itemsEl.appendChild(item)
    }
  }

  onClick (e) {
    const buttonEl = e.target

    this.setAttribute('data-button-click', 'true')

    window.setTimeout(() => {
      this.removeAttribute('data-button-click')
    }, 2000)

    const index = this.buttonEls.indexOf(buttonEl)
    this.updateActiveButton(buttonEl, index)

    window.scrollTo({
      top: getOffsetTop(
        getElement(
          `[data-floating-navigation-external-el="section"][data-floating-navigation-title="${buttonEl.firstChild.nodeValue}"]`,
        ),
      ),
      left: 0,
      behavior: 'smooth',
    })
  }

  setActiveSection () {
    if (this.hasAttribute('data-button-click')) {
      return
    }

    let maxVisibleRatio = 0
    let currentItem
    let sectionEls

    if (viewportSize() === `xs`) {
      sectionEls = this.mobileSectionEls
    } else {
      sectionEls = this.desktopSectionEls
    }

    sectionEls.forEach(item => {
      const itemRect = item.getBoundingClientRect()

      const visibleTop = Math.max(itemRect.top, 0)
      const visibleBottom = Math.min(itemRect.bottom, window.innerHeight)
      const visibleHeight = Math.max(0, visibleBottom - visibleTop)
      const ratio = visibleHeight / itemRect.height

      if (ratio > maxVisibleRatio) {
        maxVisibleRatio = ratio
        currentItem = item
      }
    })

    if (this.currentItem !== currentItem) {
      this.currentItem = currentItem
    } else {
      return
    }

    const buttonEl = this.buttonEls.find(
      el => el.textContent === currentItem?.dataset?.floatingNavigationTitle,
    )

    const index = sectionEls.indexOf(currentItem)

    if (!buttonEl) return

    this.updateActiveButton(buttonEl, index)
  }

  updateActiveButton (buttonEl, index) {
    this.buttonEls.forEach(item => {
      item.classList.toggle('nav-FloatingNav_Link-active', item === buttonEl)
    })

    this.els.items.element.dataset.activeText =
      buttonEl.dataset.floatingNavigationTitle

    if (index !== undefined && index !== -1) {
      this.setAttribute('data-current-index', index)
    }
  }

  setItemsColour () {
    const itemsRect = this.itemsEl.getBoundingClientRect()
    const itemsHeight = itemsRect.height

    if (itemsHeight === 0) return

    let overlappingSection = null
    let highestOverlapRatio = 0

    let sectionEls

    if (viewportSize() === `xs`) {
      sectionEls = this.mobileSectionEls
    } else {
      sectionEls = this.desktopSectionEls
    }

    sectionEls.forEach(section => {
      const rect = section.getBoundingClientRect()

      const overlapTop = Math.max(itemsRect.top, rect.top)
      const overlapBottom = Math.min(itemsRect.bottom, rect.bottom)

      const overlapHeight = Math.max(0, overlapBottom - overlapTop)
      const overlapRatio = overlapHeight / itemsHeight

      if (overlapRatio > highestOverlapRatio) {
        highestOverlapRatio = overlapRatio
        overlappingSection = section
      }
    })

    if (this.overlappingSection !== overlappingSection) {
      this.overlappingSection = overlappingSection
    } else {
      return
    }

    if (
      highestOverlapRatio !== 0 &&
      overlappingSection?.dataset?.navigationColour
    ) {
      this.style.setProperty(
        '--FloatingNavigation_TextColour',
        overlappingSection.dataset.navigationColour,
      )
    } else {
      this.style.removeProperty('--FloatingNavigation_TextColour')
    }
  }
}

if (!customElements.get('floating-navigation')) {
  customElements.define('floating-navigation', FloatingNavigation)
}
